// extracted by mini-css-extract-plugin
export default {"heading":"Blog_heading__PktlJ","link":"Blog_link__m8oW-","open-in-new":"Blog_open-in-new__zRM8o","author-para":"Blog_author-para__jeyHm","profile-link":"Blog_profile-link__2cUOj"};